import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { Route, Switch } from 'react-router-dom'
import { WebinarContainerComponent } from '..'
import useLocale from '../../../sharedLegacy/hooks/useLocale'
import { WebinarAppStateProvider } from '../../providers/WebinarAppStateProvider'
import { useSettingsQuery } from '../../../Settings/useSetttings'

const WebinarApp = () => (
  <WebinarAppStateProvider>
    <WebinarContainerComponent />
  </WebinarAppStateProvider>
)

const WebinarIndexComponent = (props) => {
  const { data } = useSettingsQuery()
  const localeSetting = data?.webinars?.locale
  const { updateLocale } = useLocale()

  useEffect(() => {
    // Update locale from Settings.
    if (localeSetting !== undefined) {
      updateLocale(localeSetting)
    }
  }, [localeSetting, updateLocale])

  const {
    match: { path },
  } = props

  return (
    <Switch>
      <Route path={`${path}/producer/:live_id`}>
        <WebinarApp />
      </Route>
      <Route path={`${path}/presenter/:live_id/:presenter_token`}>
        <WebinarApp />
      </Route>
    </Switch>
  )
}

WebinarIndexComponent.propTypes = {
  match: PropTypes.object,
}

export default WebinarIndexComponent
